import { render, staticRenderFns } from "./FlowEditor.vue?vue&type=template&id=af3b5130&scoped=true&"
import script from "./FlowEditor.vue?vue&type=script&lang=ts&"
export * from "./FlowEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b5130",
  null
  
)

export default component.exports